import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import CancelBookingForm from './CancelBookingForm/CancelBookingForm';
import messages from '../../locale/messages';
import { closeCancelScheduledBookingModal } from '../../actions/siteadmin/modalActions';
import bt from '../../components/commonStyle.css';


class CancelScheduledBookingModal extends Component {

    render() {
        const { cancelScheduledBookingModal, closeCancelScheduledBookingModal } = this.props;

        return (
            <>
                <Modal show={cancelScheduledBookingModal} onHide={closeCancelScheduledBookingModal} dialogClassName='commonModalContainer'>
                    <Modal.Header closeButton className='commonModalHeader'>
                        <Modal.Title>
                            <div className="commonModalTitle">  <FormattedMessage {...messages.cancelJob} /></div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='commonModalBody'>
                        <div className={cx(bt.commonSize14, bt.fontWeight400, bt.textAlignStart, bt.primaryColor)}><FormattedMessage {...messages.cancelScheduledBooking} /></div>
                        <CancelBookingForm />
                    </ Modal.Body >
                </Modal>
            </>
        )
    }
}
const mapState = (state) => ({
    cancelScheduledBookingModal: state.adminModalStatus.cancelScheduledBookingModal
});

const mapDispatch = {
    closeCancelScheduledBookingModal
};

export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(CancelScheduledBookingModal)));